import script from "./ForecastButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ForecastButton.vue?vue&type=script&setup=true&lang=js"

import "./ForecastButton.vue?vue&type=style&index=0&id=7e4f237c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4f237c"]])

export default __exports__